import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { useWorkspaceToolsStore } from "./useWorkspaceToolsStore";

/** Portals show the tools catalog to no one; elsewhere a click opens it, or, signed in, clones it. */
export const useLeadsIntoTools = (): boolean => {
	const { isWeb, isTauri } = usePlatform();
	const isLogged = PageDataContextService.value.isLogged;
	const hasLink = useWorkspaceToolsStore((store) => store.state.enabled && !!store.state.links.catalog);
	return (isWeb || isTauri) && (hasLink || isLogged);
};
